export const OBJECTIVE_PAGE_DESCRIPTION = `
Unpack learning competencies to create meaningful class objectives.
The class objectives are aligned with the 3 learning domains 
(Cognitive, Affective, Psychomotor)`;
